import { IPersonalInfoCMS, IProduct } from '@vfit/consumer/data-access';

export const organizeCoverageToolCheckNumberCard = (props: IPersonalInfoCMS) => {
  const prefix = props?.personalinfo?.lockIn;
  const modalError = {
    title: prefix?.modalNewUser?.title || '',
    description: prefix?.modalNewUser?.description || '',
    editLabel: prefix?.modalNewUser?.buttonModifyNumber || '',
    submitLabel: prefix?.modalNewUser?.action?.title || '',
  };

  // Todo: Add goNextLabel and phoneNumberLabel in CMS
  const checkNumberProps = {
    title: prefix?.personalInfo?.title || '',
    description: prefix?.personalInfo?.description || '',
    firstNameLabel: prefix?.personalInfo?.nameLabel || '',
    lastNameLabel: prefix?.personalInfo?.surnameLabel || '',
    phoneNumberLabel: prefix?.personalInfo?.phoneNumberLabel || 'Numero di telefono',
    ctaLabel: prefix?.personalInfo?.buttonLabel || '',
    goNext: prefix?.personalInfo?.goNextLabel || 'Prosegui',
  };

  return { modalError, checkNumberProps };
};

export const organizeNameFiscalCode = (
  nameFiscalCodeCms: IPersonalInfoCMS,
  product?: IProduct | null
) => ({
  title: nameFiscalCodeCms?.personalinfo?.fiscalCode?.title || '',
  description: nameFiscalCodeCms?.personalinfo?.fiscalCode?.description || '',
  firstNameLable: nameFiscalCodeCms?.personalinfo?.selectInput?.firstName || '',
  lastNameLable: nameFiscalCodeCms?.personalinfo?.selectInput?.lastName || '',
  fiscalCodeLable: nameFiscalCodeCms?.personalinfo?.selectInput?.fiscalCode || '',
  buttonLabel: nameFiscalCodeCms?.personalinfo?.generalInfo?.fcMissingLabel || '',
  legacyPopup: {
    legacyPopupIsOpen: true,
    legacyPopupTitle:
      product?.commonOverride?.legacyCtc?.title ||
      nameFiscalCodeCms?.personalinfo?.clientRecognition?.redirect?.title ||
      '',
    legacyPopupMessage:
      product?.commonOverride?.legacyCtc?.description ||
      nameFiscalCodeCms?.personalinfo?.clientRecognition?.redirect?.description ||
      '',
    legacyPopupActionText:
      product?.commonOverride?.legacyCtc?.buttonLabel ||
      nameFiscalCodeCms?.personalinfo?.clientRecognition?.redirect?.buttonLabel ||
      '',
    legacyPopupUrl:
      product?.commonOverride?.legacyCtc?.url ||
      nameFiscalCodeCms?.personalinfo?.clientRecognition?.redirect?.url ||
      '',
  },
});

export const organizeRetriveFiscalCode = (nameFiscalCodeCms: IPersonalInfoCMS) => ({
  retriveFiscalCode: {
    title: nameFiscalCodeCms?.personalinfo?.fiscalCode?.title || '',
    description: nameFiscalCodeCms?.personalinfo?.fiscalCode?.description || '',
    firstName: nameFiscalCodeCms?.personalinfo?.selectInput?.firstName || '',
    lastName: nameFiscalCodeCms?.personalinfo?.selectInput?.lastName || '',
    birthDate: nameFiscalCodeCms?.personalinfo?.selectInput?.birthdate || '',
    gender: nameFiscalCodeCms?.personalinfo?.selectInput?.gender || '',
    nationality: nameFiscalCodeCms?.personalinfo?.selectInput?.country || '',
    birthPlace: nameFiscalCodeCms?.personalinfo?.selectInput?.city || '',
    errorMessage: nameFiscalCodeCms?.personalinfo?.generalInfo?.errorMessage?.error2 || '',
    birthNation: nameFiscalCodeCms?.personalinfo?.selectInput?.birthNation || '',
    buttonLabel: nameFiscalCodeCms?.personalinfo?.fiscalCode?.buttonLabel || '',
  },
  nameFiscalCodeCard: {
    title: nameFiscalCodeCms?.personalinfo?.generalInfo?.title || '',
    titleReadOnly:
      nameFiscalCodeCms?.personalinfo?.generalInfo?.titleReadOnly ||
      nameFiscalCodeCms?.personalinfo?.generalInfo?.title ||
      '',
    description: nameFiscalCodeCms?.personalinfo?.generalInfo?.description || '',
    descriptionReadOnly:
      nameFiscalCodeCms?.personalinfo?.generalInfo?.descriptionReadOnly ||
      nameFiscalCodeCms?.personalinfo?.generalInfo?.description ||
      '',
    firstNameLable: nameFiscalCodeCms?.personalinfo?.selectInput?.firstName || '',
    lastNameLable: nameFiscalCodeCms?.personalinfo?.selectInput?.lastName || '',
    fiscalCodeLable: nameFiscalCodeCms?.personalinfo?.selectInput?.fiscalCode || '',
    buttonLabel: nameFiscalCodeCms?.personalinfo?.generalInfo?.fcMissingLabel || '',
  },
});
